var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusHideEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06094 9.16442C2.05913 9.16085 2.05734 9.15732 2.05557 9.15383C2.05734 9.15034 2.05913 9.14681 2.06094 9.14324C2.1334 9.00048 2.24299 8.7942 2.389 8.54563C2.68165 8.0474 3.11731 7.3849 3.68952 6.7247C4.84358 5.39316 6.48976 4.14062 8.5884 4.14062C10.687 4.14062 12.3332 5.39316 13.4873 6.7247C14.0595 7.3849 14.4952 8.0474 14.7878 8.54563C14.9338 8.7942 15.0434 9.00048 15.1159 9.14324C15.1177 9.14681 15.1195 9.15034 15.1212 9.15383C15.1195 9.15732 15.1177 9.16085 15.1159 9.16442C15.0434 9.30718 14.9338 9.51345 14.7878 9.76203C14.4952 10.2603 14.0595 10.9228 13.4873 11.583C12.3332 12.9145 10.687 14.167 8.5884 14.167C6.48976 14.167 4.84358 12.9145 3.68952 11.583C3.11731 10.9228 2.68165 10.2603 2.389 9.76203C2.24299 9.51345 2.1334 9.30718 2.06094 9.16442Z",
    stroke: "#585D66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9517 8.01893C10.5139 7.28605 9.69552 6.79297 8.75826 6.79297C7.35977 6.79297 6.22607 7.89073 6.22607 9.24488C6.22607 10.2739 6.8807 11.1548 7.80869 11.5186",
    stroke: "#585D66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93775 15.8367L16.4999 2.10059",
    stroke: "white",
    strokeWidth: 1.62021
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49997 15.7538L14.25 3.2285",
    stroke: "#585D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusHideEventIcon);
export default __webpack_public_path__ + "static/media/status-hide-event-icon.8d413aaffd980d04c1192bd010ebba4b.svg";
export { ForwardRef as ReactComponent };